import type { RouteRecordRaw } from "vue-router";
import { HOME_URL } from "@/config";

/**
 * staticRouter (静态路由)
 */
export const staticRouter: RouteRecordRaw[] = [
    {
        path: "/",
        redirect: HOME_URL
    },
    {
        path: "/500",
        name: "500",
        redirect: "/map",
        meta: {
            title: "查船"
        }
    },
    {
        path: "/map",
        name: "Map",
        component: () => import("@/views/pages/map/index.vue"),
        meta: {
            title: "查船"
        }
    },
    {
        path: "/search",
        name: "Search",
        component: () => import("@/views/pages/search/index.vue"),
        meta: {
            title: "搜索船舶"
        }
    },
    {
        path: "/port-search",
        name: "PortSearch",
        component: () => import("@/views/pages/search/index.vue"),
        meta: {
            title: "搜索港口"
        }
    },
    {
        path: "/findTrack",
        name: "FindTrack",
        component: () => import("@/views/pages/map/index.vue"),
        meta: {
            title: "查船"
        }
    },
    {
        path: "/findPort",
        name: "FindPort",
        component: () => import("@/views/pages/map/index.vue"),
        meta: {
            title: "查船"
        }
    },
    {
        path: "/myAttention",
        name: "MyAttention",
        component: () => import("@/views/pages/myAttention/index.vue"),
        meta: {
            title: "关注的船"
        }
    },
    {
        path: "/findMmsi",
        name: "FindMMSI",
        component: () => import("@/views/pages/map/index.vue"),
        meta: {
            title: "查船"
        }
    },
    {
        path: "/truckLocation",
        name: "TruckLocation",
        component: () => import("@/views/pages/truckLocation/index.vue"),
        meta: {
            title: "查车"
        }
    },
    {
        path: "/searchTruck",
        name: "SearchTruck",
        component: () => import("@/views/pages/searchTruck/index.vue"),
        meta: {
            title: "查询车辆"
        }
    },
    {
        path: "/oilSite",
        name: "OilSite",
        component: () => import("@/views/pages/oilSite/index.vue"),
        meta: {
            title: "站点详情"
        }
    },
    {
        path: "/pickupDetails",
        name: "PickupDetails",
        component: () => import("@/views/pages/pickupDetails/index.vue"),
        meta: {
            title: "提货详情"
        }
    },
    {
        path: "/certification",
        name: "Certification",
        component: () => import("@/views/pages/certification/index.vue"),
        meta: {
            title: "实名认证"
        }
    },
    {
        path: "/certificationDetail",
        name: "CertificationDetail",
        component: () => import("@/views/pages/certification/detail.vue"),
        meta: {
            title: "实名认证"
        }
    },
    {
        path: "/orderAddress", // 订单提货地址
        name: "CertificationDetail",
        component: () => import("@/views/pages/orderAddress/index.vue"),
        meta: {
            title: "地址"
        }
    }
];
